(() => {
  if (window.minimumOrderCheckoutListenerAdded) return;
  window.minimumOrderCheckoutListenerAdded = true;

  const minimum = 3000; // Shopify-cartbedragen zijn in centen.
  const bypass = new WeakSet();
  const pending = new WeakSet();

  function showCheckoutError(form, container, discount) {
    const currentForm = form.isConnected ? form : (form.id === 'cart' ? document.getElementById('cart') : container?.querySelector('form.drawer__footer-buttons'));
    if (!currentForm) return;
    let notice = currentForm.parentElement?.querySelector('[data-checkout-check-error]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-checkout-check-error', '');
      notice.setAttribute('role', 'alert');
      currentForm.insertAdjacentElement('beforebegin', notice);
    }
    const locale = (document.documentElement.lang || 'nl').slice(0, 2);
    notice.textContent = discount
      ? (locale === 'en' ? 'Unable to check your discount. Please try again.' : locale === 'de' ? 'Der Rabatt konnte nicht geprüft werden. Bitte versuche es erneut.' : 'De kortingscode kon niet worden gecontroleerd. Probeer het opnieuw.')
      : (locale === 'en' ? 'Unable to check your cart. Please try again.' : locale === 'de' ? 'Der Warenkorb konnte nicht geprüft werden. Bitte versuche es erneut.' : 'De winkelwagen kon niet worden gecontroleerd. Probeer het opnieuw.');
  }

  // De knoppen staan in twee verschillende formulieren. Submit afvangen werkt
  // ook voor toetsenbordgebruik en nadat Hyper de cart drawer opnieuw rendert.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!(form instanceof HTMLFormElement) ||
        !button || button.name !== 'checkout' ||
        !(form.id === 'cart' || form.classList.contains('drawer__footer-buttons'))) return;

    if (bypass.has(form)) {
      bypass.delete(form);
      return;
    }

    event.preventDefault();
    // A drawer can be re-rendered while the cart request is pending.
    // Keep the lock on the surrounding drawer, not the replaceable form.
    const container = form.closest('cart-drawer, main-cart');
    const lock = container || form;
    if (pending.has(lock)) return;
    pending.add(lock);
    form.parentElement?.querySelector('[data-checkout-check-error]')?.remove();
    const label = button.querySelector('.btn__text');
    const previousText = label?.textContent;
    const previousBusy = button.getAttribute('aria-busy');
    const locale = (document.documentElement.lang || 'nl').slice(0, 2);
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = locale === 'en' ? 'Opening checkout…' : locale === 'de' ? 'Kasse wird geöffnet…' : 'Checkout laden...';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const prepared = window.DHSWelcomeCheckoutCart;
      window.DHSWelcomeCheckoutCart = null;
      let cart;
      if (prepared && prepared.form === form && Date.now() - prepared.checkedAt < 30000) {
        cart = prepared.cart;
      } else {
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Kon winkelwagen niet ophalen');
      cart = await response.json();
      }
      function showMinimumIfNeeded() {
        if (!cart || cart.total_price >= minimum) return false;
        const message = container?.querySelector('.minimum-order-message');
        if (message) {
          const remaining = minimum - cart.total_price;
          const remainingElement = message.querySelector('[data-minimum-order-remaining]');
          const formattedRemaining = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: cart.currency || 'EUR'
          }).format(remaining / 100).replace(/\s/g, '');

          if (remainingElement) remainingElement.textContent = formattedRemaining;
          message.hidden = false;
          message.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return true;
      }
      if (showMinimumIfNeeded()) return;
      // The same cart snapshot is used by both checkout checks. This avoids
      // competing submit handlers and unnecessary duplicate cart requests.
      if (window.DHSWelcomeDiscount?.prepareCheckout) {
        try {
          cart = await window.DHSWelcomeDiscount.prepareCheckout(cart);
        } catch (error) {
          console.warn('Kortingscode kon niet worden gecontroleerd:', error);
          showCheckoutError(form, container, true);
          return;
        }
      }
      form.dhsMinimumOrderCart = cart;

      if (showMinimumIfNeeded()) return;
    } catch (error) {
      console.warn('Controle minimale bestelwaarde niet beschikbaar:', error);
      showCheckoutError(form, container, false);
      return;
    } finally {
      pending.delete(lock);
      if (label) label.textContent = previousText;
      if (previousBusy === null) button.removeAttribute('aria-busy');
      else button.setAttribute('aria-busy', previousBusy);
    }

    // Gebruik de originele submitknop, zodat Shopify de cart-formuliergegevens
    // en het checkout= veld op de normale manier verwerkt.
    // Use the current form if Shopify or an app replaced the original one.
    let activeForm = form;
    if (!form.isConnected) {
      if (form.id === 'cart') {
        activeForm = document.getElementById('cart');
      } else {
        const drawer = container?.isConnected ? container : document.querySelector('cart-drawer[open]');
        activeForm = drawer?.querySelector('form.drawer__footer-buttons');
      }
    }
    const activeButton = activeForm === form && button.isConnected ? button : activeForm?.querySelector('[name="checkout"]');
    if (!activeForm?.isConnected || !activeButton?.isConnected) {
      console.warn('Checkoutknop niet meer beschikbaar na bijwerken van de winkelwagen.');
      return;
    }
    window.DHSMinimumOrderCart = { form: activeForm, cart: form.dhsMinimumOrderCart, checkedAt: Date.now() };
    delete form.dhsMinimumOrderCart;
    bypass.add(activeForm);
    try { activeForm.requestSubmit(activeButton); } finally { window.DHSMinimumOrderCart = null; }
  }, true);
})();

